/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_NotificationService_DTOs_NotificationSettingsDto } from '../models/Wealthlane_NotificationService_DTOs_NotificationSettingsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NotificationSettingsService {

    /**
     * @returns Wealthlane_NotificationService_DTOs_NotificationSettingsDto OK
     * @throws ApiError
     */
    public static getApiNotificationApiAppNotificationSettingsNotificationSettings(): CancelablePromise<Array<Wealthlane_NotificationService_DTOs_NotificationSettingsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/notification/api/app/notification-settings/notification-settings',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
